// export const pricingData = [
//     {
//         title: "3 Bottles",
//         subtitle: "90 Days Supply",
//         pricePerBottle: 59,
//         totalBottles: 3,
//         originalPrice: 597,
//         discountedPrice: 177,
//         features: [
//             "FAST & FREE SHIPPING",
//             "180 DAY GUARANTEE"
//         ],
//         product: "https://cdn.blackincae.com/product-images/LR_Bottle_4_60ML.png",
//     },
//     {
//         title: "9 Bottles",
//         subtitle: "270 Days Supply",
//         pricePerBottle: 59,
//         totalBottles: 12,
//         originalPrice: 2388,
//         discountedPrice: 354,
//         features: [
//             "BIGGEST DISCOUNT",
//             "FAST & FREE SHIPPING",
//             "2 BONUSES",
//             "180 DAY GUARANTEE"
//         ],
//         product: "https://cdn.blackincae.com/product-images/LR_Bottle_Bottle_6_V2_60ML.png",
//         bestValue: true,
//     },
//     {
//         title: "6 Bottles",
//         subtitle: "180 Day Supply",
//         pricePerBottle: 59,
//         totalBottles: 6,
//         originalPrice: 1194,
//         discountedPrice: 295,
//         features: [
//             "FAST & FREE SHIPPING",
//             "2 BONUSES",
//             "180 DAY GUARANTEE"
//         ],
//         product: "https://cdn.blackincae.com/product-images/LR_Bottle_4_60ML.png",
//     }
// ]

import ThreeBottles from "../../../assets/landingPage/3pm.png"
import NineBottles from "../../../assets/landingPage/9.png"
import SixBottles from "../../../assets/landingPage/6v2.png"

export const pricingData = [
    {
        title: "3 Bottles",
        subtitle: "90 Days Supply",
        pricePerBottle: 49,
        totalBottles: 3,
        src: 'https://scalequick.pay.clickbank.net/?cbitems=7&cbur=a',
        originalPrice: 597,
        leastpopular: true,
        popular: false,
        discountedPrice: 147,
        freeshipping:'FAST & Free Shipping',
        product:ThreeBottles,
    },
    {
        title: "9 Bottles",
        src: 'https://scalequick.pay.clickbank.net/?cbitems=8&cbur=a',
        subtitle: "270 Days Supply",
        pricePerBottle: 29,
        totalBottles: 12,
        originalPrice: "1,791",
        discountedPrice: 261,
        leastpopular: false,
        popular: true,
        discount:' Biggest discount',
        freeshipping:'FAST & Free Shipping',
        bonuses:'2 BONUSES',
        product: NineBottles,
        bestValue: true,
    },
    {
        title: "6 Bottles ",
        src: 'https://scalequick.pay.clickbank.net/?cbitems=9&cbur=a',
        subtitle: "180 Day Supply",
        pricePerBottle: 39,
        totalBottles: 6,
        originalPrice: 1194,
        discountedPrice: 234,
        leastpopular: false,
        popular: false,
        freeshipping:'FAST & Free Shipping',
        bonuses:'2 BONUSES',
        product: SixBottles,
    }
]